// eslint-disable-next-line no-restricted-imports
import type { SwitchProps } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
import { Switch as MuiSwitch } from '@mui/material';

export type { SwitchProps };

export const Switch = ({ size = 'small', ...props }: SwitchProps) => (
  <MuiSwitch
    size={size}
    {...props}
  />
);
